<template>
    <div class="layer_wrap">
        <div class="layer_main dp_fs_color">
            <img :src="newClose" alt="" class="close_btn" @click="closeLayer">
            <div class="layer_head">
                <div class='head_tit'>
                    <span class="span_tit pseudo_cls_before">
                        单位信息列表
                    </span>
                </div>
                <div class="search-wrap">
                  <div class="input-wrap">
                    <Input
                        v-model="departName"
                        placeholder="请输入单位名称"
                    />
                  </div>
                    <Button style="margin-left: 10px" type="primary" @click="searchDepart">搜索</Button>
                </div>
            </div>
            <div class="layer_ul_tit bd_color" v-show="dataList.length">
                <ul>
                    <li v-for="(item, index) in titArr" :key="index">
                        {{item}}
                    </li>
                </ul>
            </div>
            <div class="layer_ul_wrap" id="departScroll" v-show="dataList.length">
                <ul>
                    <li v-for="(item, index) in dataList" :key="index" @click="selectDepart(index, item)">
                        <span class="select" >
                            <!-- 未选中状态 -->
                            <i class="iconfont" v-show="listSelectIndex !== index">&#xe647;</i>
                            <!-- 选中状态 -->
                            <i class="iconfont" v-show="listSelectIndex === index">&#xe612;</i>
                        </span>
                        <span class="name">
                          <Poptip
                                      trigger="hover"
                                      transfer :word-wrap="true"
                                      :content="item.name"
                                      v-if="item.name"
                              >
                           {{item.name}}
                          </Poptip>
                        </span>
                            <span class="areaName">
                              <Poptip
                                           trigger="hover"
                                           transfer :word-wrap="true"
                                           :content="item.areaName"
                                           v-if="item.areaName"
                                   >
                           {{item.areaName}}
                          </Poptip>
                        </span>
                            <span class="address">
                              <Poptip
                                              trigger="hover"
                                              transfer :word-wrap="true"
                                              :content="item.address"
                                              v-if="item.address"
                                      >
                           {{item.address}}
                          </Poptip>
                         </span>
                            <span class="industryCategoryName">
                             <Poptip
                                         trigger="hover"
                                         transfer :word-wrap="true"
                                         :content="item.industryCategoryName"
                                         v-if="item.industryCategoryName"
                                   >
                           {{item.industryCategoryName}}
                          </Poptip>
                        </span>
                    </li>
                </ul>
            </div>

            <div class="no-data-wrap" v-show="!dataList.length">
               <!-- <div id="departAni" v-show="loadDataStatus"></div>-->
                <div class="ani_wrap departSty" v-show="loadDataStatus">
                    <img :src="tableLoad" style="width: 20%"/>
                </div>
                <p class="no-data-text" v-show="!loadDataStatus">暂无数据</p>
            </div>
        </div>
    </div>
</template>
<script>
    import detail from "@/assets/img/baogao.png";
    import newClose from '@/assets/img/newClose.png';
    import tableLoad from '@/assets/img/animation.gif';
    import { getTime } from '@/assets/js/index.js';
    export default {
        name:"",
        data: () => ({
            tableLoad,
            detail: detail,
            newClose: newClose,
            dateArr:[
                '周',
                '月'
            ],
            dateInd: 0,
            titArr:[
                '选择',
                '单位名称',
                '所属区域',
                '详细位置',
                '行业类型',
            ],
            dataList:[],
            listSelectIndex: '',
            dataCount: 0,
            departName: '', //搜索单位名字
            loadMoreStatus: true, //默认可以加载更多
            loadDataStatus: true, //搜索时用到该变量
        }),
        props:[
            'layerData',
            'showStatus'
        ],
        watch: {
            layerData(res){
                if(this.dataList.length < res.totalCount){
                    this.dataList = [...this.dataList, ...res.data];
                    this.loadMoreStatus = true;
                }else{
                    this.loadMoreStatus = false;
                }
            },
            showStatus(res){
                if(!res){ //弹窗关闭状态，取消选中
                    this.listSelectIndex = '';
                }
            },
            departInfoLayer:{
                handler(newVal, oldVal){ //改变火警、报警类型
                    if(newVal==2){
                        this.closeLayer();
                        this.$store.commit('departInfoLayer',1);
                    }

                },
                deep: true,
            }
        },
        components: {
        },
        created() {

        },
        mounted() {
         /*   this.animation('departAni');*/
            let that = this;
            $JQ('#departScroll').mCustomScrollbar({
                callbacks:{
                    onTotalScroll:function(){
                        if(!that.loadMoreStatus){  //如果没有数据了，禁止滚动
                            console.log('没有更多数据');
                            //没有更多数据
                            return;
                        }else{
                            console.log('加载更多');
                            that.$emit('loadMore', 1);
                        }
                    }
                }
            });
        },
        computed: {
          departInfoLayer(){
              return this.$store.state.departInfoLayer;
          }
        },
        methods: {
            animation(obj){
                //动画
                let params = {
                    container: document.getElementById(obj),
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    animationData: this.$aniData
                };
                let anim = lottie.loadAnimation(params);
            },
            searchDepart(){ //搜索单位名字
                //事先清空一下数据
                this.dataList = [];
                this.loadMoreStatus = true;
                this.loadDataStatus = true;
                this.$nextTick(()=>{
                    this.$emit('departName',this.departName);
                });
                
            },
            selectDepart(index, item){
                if(this.listSelectIndex === index){ //如果点击自己，取消选择
                    // this.listSelectIndex = '';
                }else{
                    this.listSelectIndex = index; //设置选中的索引
                }
                this.$emit('departData', item);
            },
            closeLayer(){
                this.listSelectIndex = '';
                this.dataList = [];
                this.loadMoreStatus = true;
                this.$emit('closeLayer', true);
            },
            departDetail(id){  //获取详情信息，显示弹窗组件
                this.$emit('departData', {
                    date: new Date(),
                    id: id
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .layer_wrap{
        position: fixed;
        left: 50%;
        top: 50%;
        width: 60%;
        height: 45%;
        transform: translate(-50%, -50%);
        // overflow: hidden;
        padding: 8px;
        z-index: 10;
        .layer_main{
            height: 100%;
            box-sizing: border-box;
            padding: 20px;
            font-size: 14px;
            position: relative;
            overflow: hidden;
            background: rgba(6,18,44,1) url('../assets/img/maskBg.png') center center/101% 102% no-repeat;
            .close_btn{
                position: absolute;
                right: 18px;
                top: 15px;
                cursor: pointer;
                box-sizing: content-box;
            }
            .fs_12{
                font-size: 12px;
            }
            .layer_ul_tit{
                height: 40px;
                line-height: 40px;
                font-size: 0;
                padding-left: 10px;
                box-sizing: border-box;
                background: #0C2745;
                li{
                    display: inline-block;
                    font-size: 14px;
                    text-align: left;
                }
                li:nth-child(1){
                    width: 10%;
                    text-align: left;
                }
                li:nth-child(2){
                    width: 20%;
                    text-align: left;
                }
                li:nth-child(3){
                    width: 10%;
                }
                li:nth-child(4){
                    width: 40%;
                }
                li:nth-child(5){
                    width: 20%;
                }
            }
            .layer_ul_wrap{
                height: calc(100% - 141px);
                overflow: auto;
                li{
                    color: #E4EFF5;
                    font-size: 0;
                    &:hover{
                        background: #0C2745;
                    }
                    span{
                        font-size: 12px;
                        display: inline-block;
                        height: 40px;
                        line-height: 30px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: left;
                        padding: 5px;
                        box-sizing: border-box;
                    }
                    .select{
                        width: 10%;
                        cursor: pointer;
                        // text-align: left;
                    }
                    .name{
                        width: 20%;
                        // text-align: left;
                    }
                    .areaName{
                        width: 10%;
                        // text-align: left;
                    }
                    .address{
                        width: 40%;
                    }
                    .industryCategoryName{
                        width: 20%;
                    }
                }
                li:nth-child(2n){
                  background: #0C2745;
                }
            }
            .no-data-wrap{
                height: calc(100% - 101px);
                overflow: auto;
                #departAni{
                    height: 100%;
                }
                .no-data-text{
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .layer_head{
                overflow: hidden;
            }
            .search-wrap{
                display: flex;
                flex-direction: row;
                margin: 20px 0;
            }
        }
    }
    .departSty{
        position: fixed;
        top: 32%;
    }
</style>


// WEBPACK FOOTER //
// src/components/departLayer.vue